import React, { useState } from 'react'
import { v1 as uuid } from 'uuid'
import produce from 'immer'
import { useUpdateEffect } from 'genesis-suite/hooks'
import ValueSelector from './ValueSelector'
import EditableList from '../EditableList'
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
    container: {
        width: '100%',
    }
}))

const ValueSelectorController = ({ context, defaultRows, nodeOptions, allOptions, onChange }) => {
    const [rows, setRows] = useState(defaultRows)
    const [availableNodes, setAvailableNodes] = useState(nodeOptions)
    const classes = useStyles()

    useUpdateEffect(() => {
        const newOptions = nodeOptions && nodeOptions.filter(opt => !rows.some(obj => obj.id === opt.value))
        setAvailableNodes(newOptions)
        onChange(rows)
    }, [rows])

    if (!nodeOptions) return null

    const propsByNodeId = allOptions.reduce((acc, obj) => ({ ...acc, [obj.id]: obj.propertyOptions }), {})

    const handleRowRemove = i => setRows(produce(rows, draft => { draft.splice(i, 1) }))
    const handleRowAdd = () => setRows([...rows, { id: uuid() }])
    const handleChange = (option, id, type, property) => {
        if (type === 'node') {
            setRows(produce(rows, draft => {
                draft = draft.map(row => {
                    if (row.id === id) {
                        row.node = option.value
                        row.property = property
                    }
                    return row
                })
            }))
        } else if (type === 'values') {
            setRows(produce(rows, draft => {
                draft = draft.map(row => {
                    if (row.id === id) {
                        row.values = option.map(opt => opt.value)
                    }
                    return row
                })
            }))
        }
    }

    return (
        <EditableList onRemove={handleRowRemove} onAdd={handleRowAdd}>
            {rows && rows.map(row => {
                return (
                    <div key={row.id} className={classes.container}>
                        <ValueSelector
                            id={row.id}
                            context={context}
                            allOptions={allOptions}
                            nodeOptions={availableNodes}
                            propsByNodeId={propsByNodeId}
                            defaultNode={row.node}
                            defaultProperty={row.property}
                            defaultValues={row.values && row.values.map(val => ({ label: val, value: val }))}
                            onChange={handleChange}
                        />
                    </div>
                )
            })}
        </EditableList>
    )
}

export default ValueSelectorController
